import { Period } from '../period';

export const periodToAmount = new Map<Period, number>([
  [Period.M1, 3900],
  [Period.M3, 9900],
  [Period.M6, 15900],
  [Period.M12, 22900],
]);
